// Lowercase, strip accents/tonos and everything that is not a letter or digit,
// so "ΕΣΚΑ - Α' ΕΦΗΒΩΝ" and "εσκα α εφηβων" compare equal.
export const normalizeSearchText = (text) => (text || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .replace(/ς/g, 'σ')
  .replace(/[^\p{L}\p{N}]+/gu, ' ')
  .trim()

// Matches when the query (ignoring spaces) is a substring of the name (ignoring spaces),
// or when every query word appears somewhere in the name, in any order.
const matchesSearch = (name, query) => {
  const normalizedQuery = normalizeSearchText(query)
  if (!normalizedQuery) return true
  const normalizedName = normalizeSearchText(name)
  if (normalizedName.replace(/ /g, '').includes(normalizedQuery.replace(/ /g, ''))) return true
  return normalizedQuery.split(' ').every((word) => normalizedName.includes(word))
}

export default matchesSearch
